import { tenantApi } from '@shared/api/tenantApi';
import { unwrap, unwrapList } from '@shared/api/unwrap';

/**
 * Orders — canonical member-facing routes (`/public/orders*`,
 * `publicTenantMiddleware`). Responses use the `{ success, data }` envelope.
 */

export interface OrderSummary {
  order_id: string;
  reference: string;
  status: 'pending' | 'paid' | 'fulfilled' | 'cancelled' | 'refunded';
  placed_at: string;
  total: number;
  currency: string;
  item_count: number;
}

export interface OrderItem {
  product_id: string;
  variant_id?: string;
  name: string;
  thumbnail_url?: string;
  quantity: number;
  unit_price: number;
  line_total: number;
}

export interface OrderDetail extends OrderSummary {
  items: OrderItem[];
  subtotal: number;
  shipping?: number;
  tax?: number;
  payment_method?: string;
  shipping_address?: { line1?: string; city?: string; postal_code?: string; country?: string };
  notes?: string;
}

export async function fetchOrders(): Promise<OrderSummary[]> {
  const { data } = await tenantApi.get('/public/orders', { params: { page: 1, limit: 50 } });
  return unwrapList<OrderSummary>(data);
}

export async function fetchOrder(orderId: string): Promise<OrderDetail> {
  const { data } = await tenantApi.get(`/public/orders/${orderId}`);
  return unwrap<OrderDetail>(data);
}
